<a class="file-download-link" href="javascript:void(0)" (click)="download()">
  <img *ngIf="!inProgress" src="assets/icons/icon_download.png">
  <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
</a>